module.exports = '<svg width="52" height="32" viewBox="0 0 52 32"><path d="M8 2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V2zm14.096 13.936l9.248-9.672a2.065 2.065 0 0 0 0-2.836L28.632.584a1.869 1.869 0 0 0-2.716 0L12.592 14.516a2.075 2.075 0 0 0 0 2.844L26.04 31.412a1.862 1.862 0 0 0 2.716 0l2.716-2.836a2.07 2.07 0 0 0 0-2.84l-9.376-9.8zm29.372 9.8l-9.372-9.796 9.248-9.672a2.065 2.065 0 0 0 0-2.836L48.628.588a1.869 1.869 0 0 0-2.716 0l-13.32 13.928a2.075 2.075 0 0 0 0 2.844l13.444 14.052a1.862 1.862 0 0 0 2.716 0l2.716-2.836a2.07 2.07 0 0 0 0-2.84z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/previous-3.js
// module id = 1356
// module chunks = 14